import React, { useState } from 'react';
import { SectionReveal } from './ui/SectionReveal';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function ContactSection() {
  const {
    t
  } = useLanguage();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate CRM submission
    setIsSubmitted(true);
    setTimeout(() => setIsSubmitted(false), 5000);
  };
  return <SectionReveal id="contacto" className="p-0 relative" data-id="element-87">
      <div className="absolute inset-0 z-0" data-id="element-88">
        <img src="https://images.unsplash.com/photo-1514924013411-cbf25faa35bb?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Atardecer en Tenerife" className="w-full h-full object-cover" data-id="element-89" />
        <div className="absolute inset-0 bg-navy/80 backdrop-blur-sm" data-id="element-90"></div>
      </div>

      <div className="container relative z-10 mx-auto px-6 md:px-12 py-24 lg:py-32" data-id="element-91">
        <div className="max-w-3xl mx-auto bg-white rounded-3xl overflow-hidden shadow-2xl p-8 md:p-12" data-id="element-92">
          <div className="text-center mb-10" data-id="element-93">
            <h2 className="text-4xl font-serif text-navy mb-4" data-id="element-94">
              {t.contact.title}
            </h2>
            <p className="text-gray-600" data-id="element-95">{t.contact.subtitle}</p>
          </div>

          {isSubmitted ? <div className="flex flex-col items-center justify-center text-center space-y-6 py-12" data-id="element-96">
              <CheckCircle2 className="w-20 h-20 text-nature" data-id="element-97" />
              <h3 className="text-3xl font-serif text-navy" data-id="element-98">
                {t.contact.form.successTitle}
              </h3>
              <p className="text-gray-600 text-lg" data-id="element-99">
                {t.contact.form.successDesc}
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-100">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-101">
                <div className="space-y-2" data-id="element-102">
                  <label htmlFor="name" className="text-sm font-medium text-gray-700" data-id="element-103">
                    {t.contact.form.name} *
                  </label>
                  <input required type="text" id="name" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-navy focus:ring-1 focus:ring-navy outline-none transition-all bg-light/50" placeholder={t.contact.form.namePlaceholder} data-id="element-104" />
                </div>
                <div className="space-y-2" data-id="element-105">
                  <label htmlFor="phone" className="text-sm font-medium text-gray-700" data-id="element-106">
                    {t.contact.form.phone} *
                  </label>
                  <input required type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-navy focus:ring-1 focus:ring-navy outline-none transition-all bg-light/50" placeholder={t.contact.form.phonePlaceholder} data-id="element-107" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-108">
                <label htmlFor="email" className="text-sm font-medium text-gray-700" data-id="element-109">
                  {t.contact.form.email} *
                </label>
                <input required type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-navy focus:ring-1 focus:ring-navy outline-none transition-all bg-light/50" placeholder={t.contact.form.emailPlaceholder} data-id="element-110" />
              </div>

              <div className="space-y-2" data-id="element-111">
                <label htmlFor="type" className="text-sm font-medium text-gray-700" data-id="element-112">
                  {t.contact.form.typeLabel}
                </label>
                <select id="type" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-navy focus:ring-1 focus:ring-navy outline-none transition-all bg-light/50" data-id="element-113">
                  <option value="" data-id="element-114">{t.contact.form.typePlaceholder}</option>
                  <option value="apt2" data-id="element-115">{t.contact.form.options.apt2}</option>
                  <option value="apt3" data-id="element-116">{t.contact.form.options.apt3}</option>
                  <option value="th2" data-id="element-117">{t.contact.form.options.th2}</option>
                  <option value="th3" data-id="element-118">{t.contact.form.options.th3}</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-119">
                <label htmlFor="message" className="text-sm font-medium text-gray-700" data-id="element-120">
                  {t.contact.form.message}
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-navy focus:ring-1 focus:ring-navy outline-none transition-all resize-none bg-light/50" placeholder={t.contact.form.messagePlaceholder} data-id="element-121"></textarea>
              </div>

              <div className="flex items-start gap-3 pt-2" data-id="element-122">
                <input required type="checkbox" id="rgpd" className="mt-1 w-4 h-4 text-navy border-gray-300 rounded focus:ring-navy" data-id="element-123" />
                <label htmlFor="rgpd" className="text-sm text-gray-600 leading-tight" data-id="element-124">
                  {t.contact.form.rgpd}
                </label>
              </div>

              <div className="pt-6" data-id="element-125">
                <Button type="submit" className="w-full text-lg h-14" size="lg" data-id="element-126">
                  {t.contact.form.submitBtn}
                </Button>
              </div>
            </form>}
        </div>
      </div>
    </SectionReveal>;
}